// Authentication related
export const LOGOUT = "LOGOUT";

// Setters
export const SET_GROUP_ID = "SET_GROUP_ID";
export const SET_POPUP = "SET_POPUP";
export const SET_LOADING = "SET_LOADING";
export const SET_LOGIN_ERROR = "SET_LOGIN_ERROR";
export const SET_TOKEN = "SET_TOKEN";
export const SET_AUTHENTICATED = "SET_AUTHENTICATED";
export const SET_USER = "SET_USER";
export const SET_PUBLIC_CLIENT = "SET_PUBLIC_CLIENT";
export const SET_DOCUMENT_DATA = "SET_DOCUMENT_DATA";
export const SET_SELECTED_DOCUMENTS = "SET_SELECTED_DOCUMENTS";
export const SET_PARENT_ID = "SET_PARENT_ID";
export const SET_IS_ROOT_DIR = "SET_IS_ROOT";
export const SET_CLIENT_ID = "SET_CLIENT_ID";
export const SET_AUTHORITY = "SET_AUTHORITY";
export const SET_RESOURCE_DENIED = "SET_RESOURCE_DENIED";
